(ns bp-clients.tv-app.api.graphql.utils
  "Namespace with utility functions for building and decoding graphql requests")

(defn decode-response
  "Decodes a graphql response /json into clojure"
  [{:keys [graphql unpack]} response]
  (let [unpacked  (unpack response)
        operation (-> graphql :operationName keyword)]
    (get unpacked operation unpacked)))

(defn query-builder
  "Build a maps which is used to pass down to re-graph
  It has the following shape
  {:decoder fn
   :query string
   :variables map}"
  ([query-fn]
   (query-builder query-fn decode-response nil))
  ([query-fn variables]
   (query-builder query-fn decode-response variables))
  ([query-fn decoder-fn variables]
   (let [{:keys [graphql] :as query} (query-fn variables)
         decoder                     {:decoder (partial decoder-fn query)}]
     (merge decoder (select-keys graphql [:query :variables])))))
